var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _path6, _path7, _path8, _path9, _ellipse, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon, _path42, _path43, _path44, _polygon2, _polygon3, _polygon4, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _ellipse2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _circle5, _circle6, _circle7, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _ellipse3, _path64, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _polygon0, _polygon1, _rect4, _path93, _path94;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceControlOfo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 972.57,
    height: 830.55,
    viewBox: "0 0 972.57 830.55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voice control") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.55,64.39c29.21-26,75.06-31.33,116.79-29.26,131.09,6.51,249.43,69.8,351.79,141.39,37,25.91,73.53,53.84,97.59,89.53,49,72.65,34.44,173.29-33.65,233.13-23.16,20.37-51.25,36-80.07,49.81-51.26,24.61-106.57,44.36-164.75,50-41.49,4-83.49.75-124.73-4.84C427.28,578.5,314.17,543.94,219.37,484.82c-41.58-25.93-80.77-58.17-97.91-100.12s-6.17-95.12,36.29-119.95c17.56-10.27,38.55-14.9,59.11-19.26,30.25-6.41,61-12.73,88.3-25.76,28.2-13.46,61.59-39.5,56-69.29C355.18,118.47,350.37,90.39,379.55,64.39Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499.58,314.11V431.68a52.62,52.62,0,0,0,52.66,52.65h70.2A47.27,47.27,0,0,0,669.74,437V314.11a85.08,85.08,0,0,0-170.16,0Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.58,314.11V431.68a52.62,52.62,0,0,0,52.66,52.65h70.2A47.27,47.27,0,0,0,669.74,437V314.11a85.08,85.08,0,0,0-170.16,0Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M502.11,315.37V429.45a51.06,51.06,0,0,0,51.09,51.08h68.12a45.86,45.86,0,0,0,45.89-45.88V315.37a82.55,82.55,0,0,0-165.1,0Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.61,332.23v94.88a45.51,45.51,0,0,0,6.89,24.29c6.94,11,18.46,18.19,31.51,18.19h51.21c12.44,0,23.34-7.27,29.4-18.19a41,41,0,0,0,5.09-20V332.23c0-37.91-27.78-68.65-62.05-68.65-17.13,0-32.64,7.68-43.87,20.11A72.26,72.26,0,0,0,522.61,332.23Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.45,
    cy: 623.42,
    r: 9.39,
    fill: "#333f4f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.65,
    cy: 660.16,
    r: 9.39,
    fill: "#333f4f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.12,
    cy: 666.81,
    r: 9.39,
    fill: "#333f4f"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.69,
    cy: 618.88,
    r: 9.39,
    fill: "#333f4f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 464.64,
    y: 457.59,
    width: 11.76,
    height: 73.47,
    fill: "#333f4f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 464.64,
    y: 519.17,
    width: 11.76,
    height: 11.9,
    fill: "#333f4f",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 576.08,
    y: 556.69,
    width: 16.3,
    height: 81.52,
    transform: "translate(1054.75 1160.17) rotate(-180)",
    fill: "#333f4f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M474.44,637.68l106.71-4.37v17.14H457.31A18.92,18.92,0,0,1,474.44,637.68Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M687.87,637.68l-106.72-4.37v17.14H705A18.92,18.92,0,0,0,687.87,637.68Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M592.39,635.06l85.19,42a21.56,21.56,0,0,1,12,19.35v1.27l-99.5-43.38-14-1-82.74,52.83h0a21.58,21.58,0,0,1,8.91-20.49l73.83-52.28Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M578.36,492.32v7.92q3.07.12,6.29.12c1.85,0,3.67,0,5.46-.09v-7.95Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.94,
    cy: 450.15,
    rx: 43.39,
    ry: 12.69,
    fill: "#333f4f"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M541.64,484.87a5.16,5.16,0,0,0,1.85,3.67,11.63,11.63,0,0,0,1.38,1.14c6.46,4.62,22,7.88,40.15,7.88s33.82-3.29,40.25-7.95a9.78,9.78,0,0,0,.92-.72,5.46,5.46,0,0,0,2.23-4c0-7-19.42-12.69-43.4-12.69S541.64,477.86,541.64,484.87Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M541.64,484.87a5.16,5.16,0,0,0,1.85,3.67,11.63,11.63,0,0,0,1.38,1.14c6.46,4.62,22,7.88,40.15,7.88s33.82-3.29,40.25-7.95a9.78,9.78,0,0,0,.92-.72,5.46,5.46,0,0,0,2.23-4c0-7-19.42-12.69-43.4-12.69S541.64,477.86,541.64,484.87Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M541.27,484.87a5.15,5.15,0,0,0,1.85,3.67c5.53-1.37,9.35-2.52,9.35-2.52s38.24,2.14,73.35,2.87a5.45,5.45,0,0,0,2.23-4c0-7-19.42-12.69-43.4-12.69S541.27,477.86,541.27,484.87Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M511.27,458.65a51,51,0,0,0,41.93,21.88h68.12a45.85,45.85,0,0,0,39.12-21.88Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M541.64,484.87a5.16,5.16,0,0,0,1.85,3.67,11.63,11.63,0,0,0,1.38,1.14,653.62,653.62,0,0,0,80.4-.07,9.78,9.78,0,0,0,.92-.72,5.46,5.46,0,0,0,2.23-4c0-7-19.42-12.69-43.4-12.69S541.64,477.86,541.64,484.87Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M502.64,483.71a657.47,657.47,0,0,0,164.78,0A11.53,11.53,0,0,0,679,472.18h0a11.53,11.53,0,0,0-11.53-11.53H502.64a11.53,11.53,0,0,0-11.53,11.53h0A11.53,11.53,0,0,0,502.64,483.71Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M654.51,609.29s11.37,11.64,19.13,12.75,14.14,26.06,3.33,28-31.61-5.82-34.66-9.15-14.14-23-14.14-23Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M591.85,485.08s27.73,52.95,28.28,60.16S644.25,583,644.25,583L614.86,620.1s-3.88-9.43-10.53-12.76-5.27-10.81-5.27-10.81-6.93,0-11.92-8.32S576.05,571.58,576.05,568s-36.6-41.31-36.6-41.31l2.77-40.2,7.49-12.75Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M663.94,488.13l.24.21c3.36,3,41.07,36.42,41.07,37.21s13.58,23.29-3.33,42.7-55.73,51.29-55.73,51.29-16.91,12.2-19.13,14.7-35.76,0-15.8-22.74,38.81-48.24,38.81-48.24-33.27-8-35.48-13.58,43.8-74.86,43.8-74.86Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M665.05,488.13l.24.21c3.36,3,41.07,36.42,41.07,37.21s13.58,23.29-3.33,42.7-55.73,51.29-55.73,51.29-16.91,12.2-19.13,14.7-35.77,0-15.8-22.74,38.81-48.24,38.81-48.24-33.27-8-35.49-13.58-46-73.48-46-73.48l89.83-1.38Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M569.12,339l3.32,30.22s34.1,13.59,34.94,13.31,22.73-20,19.13-33c-1.81-6.53-2.64-15.59-3-23s-.31-13.05-.31-13.05-49.63-17.75-45.19-5.55c1.61,4.43.88,9.74-.7,14.7A68.46,68.46,0,0,1,569.12,339Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#fbbebe"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M577.29,322.61c.3.35.61.68.92,1a33.25,33.25,0,0,0,45.28,2.88c-.38-7.34-.31-13.05-.31-13.05s-49.63-17.75-45.19-5.55C579.6,312.34,578.87,317.65,577.29,322.61Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M569.12,299.68a33.26,33.26,0,1,0,33.27-33.27A33.06,33.06,0,0,0,569.12,299.68Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#fbbebe"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M610.15,370.34s13-28.88,17.47-28.88S639,490.85,639,490.85l-67.92,1.06-2.78-78.43L582.15,344S594.62,371.41,610.15,370.34Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M610.15,372.56s13-28.88,17.47-28.88S639,493.06,639,493.06l-77.07,1.17,6.37-78.53,13.87-69.53S594.62,373.63,610.15,372.56Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M610.15,371.45s13-28.88,17.47-28.88S639,492,639,492l-77.07,1.17,6.37-78.53,13.87-69.53S594.62,372.52,610.15,371.45Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M622.79,333.5s2.33-3.41,5.66-2.3,5.82-1.94,9.15,1.11,16.63,7.21,19.13,5.82,11.36,4.72,13.31,8.32,8.31,13.31,8.31,13.31,5.55,6.65,4.72,10.26,1.94,7.76,5.26,9.42,10,18.3,10,18.3S696.52,420,704,423.87s1.94,20.8,1.94,20.8l-35.36-8.39-10-22.74s3.88,66.55,8.59,72.64,5.27,10,5.27,10-18.3,3.88-22.18,7.2-14.14-.83-14.14-.83l-10-88.44s-3.6-16.64-3.6-25.23S622.79,333.5,622.79,333.5Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M623.9,333.5s2.33-3.41,5.66-2.3,5.82-1.94,9.15,1.11,16.63,7.21,19.13,5.82,11.36,4.72,13.3,8.32,8.32,13.31,8.32,13.31,5.55,6.65,4.72,10.26,1.94,7.76,5.26,9.42,10,18.3,10,18.3-1.79,22.25,5.7,26.13c1.87,1,2.93,3.13,3.46,5.83,2.15,10.86-6.76,20.8-17.83,20.46l-19-7.88-10-28.74s3.88,66.55,8.59,72.64,5.27,10,5.27,10-18.3,3.88-22.18,7.2-14.14-.83-14.14-.83l-10-88.44s-3.6-16.64-3.6-25.23S623.9,333.5,623.9,333.5Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M685,381.66s-3.33,9.15-12.48,8.32S685,381.66,685,381.66Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M676.14,367.8s-6.1,1.11-8.32,6.37S676.14,367.8,676.14,367.8Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M659,358.37c0,1.11-3.89,20.52,0,28.56s3.32,17.47,3.32,17.47Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M577.11,326.82s-2.17-2.55-4.39-2.27-3.6,1.66-6.38,2.77-9.42,1.39-9.42,2.22-5.83,4.16-9.71,5-16.08,9.15-19.13,25.23-8.32,20.79-8.32,20.79L549.15,395s-22.73,96.48-25.5,103.41-3,48-3,48,18,8,22.73,10.53,2.77-23.84,12.48-39.09,20.79-37.43,20.79-37.43L593.51,433s10.82-63.21,1.67-74.86S576.28,331,577.11,326.82Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M576,326.82s-2.17-2.55-4.39-2.27-3.6,1.66-6.38,2.77-9.42,1.39-9.42,2.22-5.82,4.16-9.71,5S530,343.68,527,359.76s-8.31,20.79-8.31,20.79L548,395s-22.73,96.48-25.5,103.41-3,48-3,48,18,8,22.73,10.53S545,533,554.7,517.79s20.79-37.43,20.79-37.43L592.4,433s10.82-63.21,1.67-74.86S575.17,331,576,326.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M515.88,448.2c.82.13,1.87.26,3.08.37,8.88.81,26.31,1,26.31,1s13-25.79,24.12-25c0,0-10.26-11.64-14.41-10.25-.7.23-1.14-.28-1.35-1.28-1.11-5,2.73-22,2.73-22l5.27-23-30.5,7.48c-2.77.56-11.37,5-11.37,5s-.27,11.92-2.49,14.7-4.71,16.08-4.44,19.4-3.05,18.86.28,23S509,447.09,515.88,448.2Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M629.83,629.8s1.67,9.15-.27,15-1.67,18.58-.28,23,6.1,10.53-6.65,13.3-21.35.28-21.91-1.94-3.32-11.09-1.11-16.08,3-18-1.11-25.51-1.38-19.13,2.5-20.51,10.54-4.44,10.54-4.44-7.21,13-.56,15.81S629.83,629.8,629.83,629.8Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M569.12,299.68a33.06,33.06,0,0,0,9.09,22.84,1.19,1.19,0,0,0,.08-.16c1-2.11,1.93-4.3,1.85-6.61-.09-2.79-1.7-5.31-2.22-8.07-.65-3.48.49-7,1.61-10.38.82-2.46,2.41-5.45,5-5.15a5.76,5.76,0,0,0,1.53.18c1.37-.21,1.65-2,1.81-3.38a15.35,15.35,0,0,1,12.53-13.16,3.88,3.88,0,0,1,2.19.15c1,.43,1.49,1.47,2.36,2.07,2.81,1.95,6.39-1.78,9.81-1.49,2.91.24,4.68,3.21,5.88,5.87s2.69,5.69,5.54,6.31a1.75,1.75,0,0,0,1.35-.15c.88-.65.27-2-.18-3-1.17-2.64-.39-4.73,1-6.61a33.26,33.26,0,0,0-59.25,20.76Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M627.33,284.42c.45,1,1.07,2.38.17,3a1.68,1.68,0,0,1-1.34.15c-2.85-.61-4.35-3.65-5.55-6.31s-3-5.63-5.87-5.87c-3.42-.29-7,3.44-9.82,1.49-.86-.6-1.39-1.64-2.35-2.07a3.88,3.88,0,0,0-2.19-.14,15.35,15.35,0,0,0-12.54,13.15c-.14,1.37-.43,3.17-1.8,3.38a5.72,5.72,0,0,1-1.53-.18c-2.58-.3-4.16,2.68-5,5.14-1.12,3.37-2.26,6.91-1.61,10.39.52,2.76,2.13,5.28,2.22,8.08.07,2.3-.9,4.5-1.85,6.6s-2.52,4.56-4.8,4.26c-1.88-.24-2.91-2.23-3.81-3.9s-2.52-3.45-4.34-2.93c-.82.24-1.66.93-2.4.51a1.75,1.75,0,0,1-.7-1.21c-.89-3.87.39-8.23-1.5-11.73-1.45-2.69-4.39-4.15-6.78-6.06a19.42,19.42,0,0,1-2.63-27.8c2.56-3,6.24-5.64,6.45-9.57.15-3-1.87-5.75-1.89-8.75s1.85-5.52,4-7.51a25.83,25.83,0,0,1,23.22-6.12c2.15.52,4.31,1.32,6.5,1.05,2.55-.32,4.67-2,7-3.18a17.8,17.8,0,0,1,22.21,6c2.62,4.09,3.65,9.42,7.57,12.29,2.57,1.88,6.27,2.59,7.69,5.44.85,1.72.61,3.75.35,5.64a13.2,13.2,0,0,1-4.22,8.08C627.78,278.22,625.73,280.81,627.33,284.42Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#512e4e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.57,257.46a14.78,14.78,0,0,1-.59-2.31A14.5,14.5,0,0,1,556.57,257.46Z",
    transform: "translate(-113.71 -34.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.77,282a9,9,0,0,0-.55-1.48c-1.6-3.62.45-6.2,2.84-8.62a13.23,13.23,0,0,0,4.21-8.08,20,20,0,0,0,.24-2.56,5.49,5.49,0,0,1,.52.8c.85,1.72.61,3.75.35,5.64a13.2,13.2,0,0,1-4.22,8.08C628.34,277.65,626.72,279.59,626.77,282Z",
    transform: "translate(-113.71 -34.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.23,314.8c1.82-.53,3.44,1.27,4.34,2.93s1.93,3.66,3.81,3.9c2.28.29,3.85-2.17,4.8-4.26s1.93-4.3,1.85-6.6a7.77,7.77,0,0,0-.08-.83,15,15,0,0,1,1.19,4.71c.07,2.3-.9,4.5-1.85,6.6s-2.52,4.56-4.8,4.26c-1.88-.24-2.91-2.23-3.81-3.9s-2.52-3.45-4.34-2.93c-.82.24-1.66.93-2.4.51a1.75,1.75,0,0,1-.7-1.21,15.37,15.37,0,0,1-.33-2.64C562.63,315.66,563.45,315,564.23,314.8Z",
    transform: "translate(-113.71 -34.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.85,296.31c2.39,1.91,5.34,3.37,6.79,6.06a9.62,9.62,0,0,1,1,3.75c-1.47-2.6-4.35-4.05-6.7-5.93a19.59,19.59,0,0,1-7-11.85A19.46,19.46,0,0,0,552.85,296.31Z",
    transform: "translate(-113.71 -34.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.86,306.11a21.77,21.77,0,0,1-1.05-3.42c-.65-3.48.49-7,1.61-10.39.82-2.46,2.41-5.44,5-5.14a5.76,5.76,0,0,0,1.53.18c1.37-.21,1.66-2,1.8-3.39a15.37,15.37,0,0,1,12.54-13.14,3.79,3.79,0,0,1,2.19.14c1,.43,1.49,1.47,2.35,2.07,2.82,2,6.4-1.78,9.82-1.49,2.9.24,4.68,3.21,5.88,5.87s2.7,5.69,5.54,6.31a1.68,1.68,0,0,0,1.34-.15,1.08,1.08,0,0,0,.44-.83,6.55,6.55,0,0,0,.5,1.69c.45,1,1.07,2.38.17,3a1.68,1.68,0,0,1-1.34.15c-2.85-.61-4.35-3.65-5.55-6.31s-3-5.63-5.87-5.87c-3.42-.29-7,3.44-9.82,1.49-.86-.6-1.39-1.64-2.35-2.07a3.88,3.88,0,0,0-2.19-.14,15.35,15.35,0,0,0-12.54,13.15c-.14,1.37-.43,3.17-1.8,3.38a5.72,5.72,0,0,1-1.53-.18c-2.58-.3-4.16,2.68-5,5.14C578.46,299.4,577.39,302.78,577.86,306.11Z",
    transform: "translate(-113.71 -34.73)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M519,448.57c8.88.81,26.31,1,26.31,1s13-25.79,24.12-25c0,0-10.26-11.64-14.41-10.25-.7.23-1.14-.28-1.35-1.28-10.86,3.32-31.56,11.43-33.59,25.67C519.5,442.59,519.15,445.83,519,448.57Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M517.85,448.57c8.88.81,26.31,1,26.31,1s13-25.79,24.12-25c0,0-10.25-11.64-14.41-10.25-.7.23-1.13-.28-1.35-1.28-10.86,3.32-31.56,11.43-33.59,25.67C518.39,442.59,518.05,445.83,517.85,448.57Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M595.73,522.78s-25-6.1-28.83-2.77S595.73,522.78,595.73,522.78Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M667.26,546.63s-10.53,6.1-11.64,11.09S667.26,546.63,667.26,546.63Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M625.12,659s-14.42-2.22-18.11.18S625.12,659,625.12,659Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M481.07,852.54s55.88-3,69.5-11,32.9-8,33-8L806.07,785l92.5-22,16.5-2.17-54.5-62.36-1.66-.72L778.57,663s-36,2-43.11,25.46a28.15,28.15,0,0,0-1,5.06,29.33,29.33,0,0,0,5.68,20.53c2.84,3.89,6.33,9.39,7.43,14.25.62,2.74.48,5.27-1,7.2a58.69,58.69,0,0,1-9.88,7.89c-19.59,13-69.11,34.42-155.62,1.61,0,0-37-36.5-65-21S481.07,852.54,481.07,852.54Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#e1dee5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M747.53,728.34c.62,2.74.48,5.27-1,7.2a58.69,58.69,0,0,1-9.88,7.89L905.07,756l-46.16-58.25L778.57,663s-36,2-43.11,25.46a28.15,28.15,0,0,0-1,5.06,29.33,29.33,0,0,0,5.68,20.53C742.94,718,746.43,723.48,747.53,728.34Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "798.36 464.31 660.36 467.31 660.36 632.5 791.36 721.31 822.86 692.31 816.36 596.31 822.86 506.81 798.36 464.31",
    fill: "#65617d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M990.57,472,829.45,422.39a24.2,24.2,0,0,0-9-1l-384.9,28.1a181.72,181.72,0,0,0-91.66,32.33c-24.91,17.57-49.58,44.54-61,85.37A163,163,0,0,0,284.62,659l33.95,110s-25.5-239,229-251Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#d9d6df"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M740.1,714.09c2.84,3.89,6.33,9.39,7.43,14.25,4.36-5.05,5.3-10.75-1-15.3-7.89-5.74-10.52-15.7-11.11-24.54a28.15,28.15,0,0,0-1,5.06A29.33,29.33,0,0,0,740.1,714.09Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#fff",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M336.07,741l19,64.5,43,42,54,11,84-15V545s-14.5-9.5-16-9.5-42,6.5-42,6.5l-91.7,65.77-3.8,2.73-41,61Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.36 497.81 422.36 808.81 414.26 810.26 414.26 497.81 422.36 497.81",
    fill: "#65617d"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "798.36 464.31 660.36 467.31 660.36 632.5 791.36 721.31 822.86 692.31 816.36 596.31 822.86 506.81 798.36 464.31",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.36 497.81 422.36 808.81 414.26 810.26 414.26 497.81 422.36 497.81",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M384.57,628.54c60-49.3,126.7-56.55,151.5-57.45V545s-14.5-9.5-16-9.5-42,6.5-42,6.5l-91.7,65.77Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.57,602s-6.19,16.36-12.83,35.41c-5.88,16.93-12.12,36-14.67,47.59-1,4.43-3.51,9-7.06,13.47-16.19,20.55-53.5,40.46-59.94,47.53-7.85,8.62-52,14.83-52,14.83V495.54l29.5-9.5h37.5l48.5,22,25,37Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M537,446.82c1.94,2.36,60.86,2.91,63.91,2.22l5.54-1.25s28.44,15.31,48-9.74c.84-1.07,1.66-2.21,2.46-3.43,19.55-29.8-45.61-8-45.61-8s-24.95.14-31.33.14h-.66c-6.63-.27-19.85-4.29-19.85-4.29S535.07,444.47,537,446.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#fbbebe"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M623,437.84s24.95.14,31.33.21h.15c.84-1.07,1.66-2.21,2.46-3.43,19.55-29.8-45.61-8-45.61-8s-24.95.14-31.33.14h-.66c-.63.82-1.25,1.68-1.86,2.59C557.59,458.89,623,437.84,623,437.84Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M674.78,440.58s-14.09-4.46-20.47-4.53-31.33-.2-31.33-.2-65.39,21-45.52-8.55,50.61-12.61,50.61-12.61l5.55-1.19c3.06-.66,62,.55,63.88,2.93S674.78,440.58,674.78,440.58Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#fbbebe"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M704,423.87s-.4,19.23-13.73,20.33c-28,2.29-20.88-8.53-20.88-8.53l2.42-21.54L685,402.19s5.79,2.66,6.54,2.21S704,423.87,704,423.87Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M514.77,448.2c.82.13,1.87.26,3.08.37,8.88.81,26.31,1,26.31,1s13-25.79,24.12-25c0,0-10.25-11.64-14.41-10.25-.7.23-1.13-.28-1.35-1.28-1.1-5,2.73-22,2.73-22l5.27-23L530,375.56c-2.77.56-11.36,5-11.36,5s-.28,11.92-2.5,14.7-4.71,16.08-4.44,19.4-3.05,18.86.28,23S507.84,447.09,514.77,448.2Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M546.1,387.76s-25.5,2.77-26.61,9.15S546.1,387.76,546.1,387.76Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M530.85,412.71c-1.66.56-11.36,3.05-13.3,8.88S530.85,412.71,530.85,412.71Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M519,449.6c8.88.81,26.31,1,26.31,1s13-25.79,24.12-25c0,0-10.26-11.64-14.41-10.25-.7.23-1.14-.28-1.35-1.28-10.86,3.32-31.56,11.43-33.59,25.67C519.5,443.62,519.15,446.86,519,449.6Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M712.58,351.32V462.25c0,1.91-1,2.18-2.69,3.11-5.62,3.12-19.49,8.67-36.13-.12-1.71-.9-2.76-1.21-2.76-3.14V352S692.15,360.56,712.58,351.32Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#333f4f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.08,
    cy: 316.52,
    rx: 20.79,
    ry: 4.42,
    fill: "#2d394a",
    stroke: "#40868e",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 362.66,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 363.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 364.25,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 365.38,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 366.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 366.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 365.19,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 365.85,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 364.25,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 364.72,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 363.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 364.92,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 365.85,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 366.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 366.32,
    r: 0.47
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 364.95,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 365.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 366.55,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 367.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 368.35,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 368.61,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 367.48,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 368.15,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 366.55,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 367.02,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 365.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 367.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 368.15,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 368.61,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 368.61,
    r: 0.47
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 367.25,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 367.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 368.84,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 369.97,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 370.64,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 370.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 369.78,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 370.44,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 368.84,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 369.31,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 367.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 369.51,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 370.44,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 370.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 370.91,
    r: 0.47
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 369.55,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 370.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 371.14,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 372.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 372.94,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 373.2,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 372.07,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 372.74,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 371.14,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 371.61,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 370.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 371.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 372.74,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 373.2,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 373.2,
    r: 0.47
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 371.84,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 372.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 373.44,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 374.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 375.24,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 375.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 374.37,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 375.03,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 373.44,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 373.9,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 372.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 374.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 375.03,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 375.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 375.5,
    r: 0.47
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 374.14,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 374.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 375.73,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 376.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 377.53,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 377.79,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 376.66,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 377.33,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 375.73,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 376.2,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 374.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 376.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 377.33,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 377.79,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 377.79,
    r: 0.47
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 376.43,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 377.09,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 378.03,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 379.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 379.83,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 380.09,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 378.96,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 379.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 378.03,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 378.49,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 377.09,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 378.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 379.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 380.09,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 380.09,
    r: 0.47
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 378.73,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 379.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 380.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 381.45,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 382.12,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 382.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 381.26,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 381.92,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 380.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 380.79,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 379.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 380.99,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 381.92,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 382.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 382.39,
    r: 0.47
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 381.02,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 381.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 382.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 383.75,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 384.42,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 384.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 383.55,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 384.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 382.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 383.08,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 381.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 383.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 384.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 384.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 384.68,
    r: 0.47
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 383.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 383.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 384.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 386.04,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 386.71,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 386.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 385.85,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 386.51,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 384.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 385.38,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 383.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 385.58,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 386.51,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 386.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 386.98,
    r: 0.47
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 385.61,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 386.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 387.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 388.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 389.01,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 389.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 388.14,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 388.81,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 387.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 387.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 386.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 387.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 388.81,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 389.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 389.27,
    r: 0.47
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 387.91,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 388.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 389.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 390.63,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 391.3,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 391.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 390.44,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 391.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 389.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 389.97,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 388.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 390.17,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 391.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 391.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 391.57,
    r: 0.47
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 390.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 390.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 391.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 392.93,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 393.6,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 393.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 392.73,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 393.4,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 391.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 392.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 390.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 392.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 393.4,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 393.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 393.86,
    r: 0.47
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 392.5,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 393.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 394.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 395.23,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 395.9,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 396.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 395.03,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 395.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 394.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 394.56,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 393.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 394.76,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 395.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 396.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 396.16,
    r: 0.47
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 394.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 395.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 396.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 397.52,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 398.19,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 398.45,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 397.32,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 397.99,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 396.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 396.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 395.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 397.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 397.99,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 398.45,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 398.45,
    r: 0.47
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 397.09,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 397.75,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 398.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 399.82,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 400.49,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 400.75,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 399.62,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 400.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 398.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 399.15,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 397.75,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 399.35,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 400.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 400.75,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 400.75,
    r: 0.47
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 399.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 400.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 400.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 402.11,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 402.78,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 403.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 401.92,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 402.58,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 400.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 401.45,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 400.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 401.65,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 402.58,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 403.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 403.05,
    r: 0.47
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 401.68,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 402.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 403.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 404.41,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 405.08,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 405.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 404.21,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 404.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 403.28,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 403.74,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 402.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 403.94,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 404.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 405.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 405.34,
    r: 0.47
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 403.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 404.64,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 405.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 406.7,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 407.37,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 407.64,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 406.51,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 407.17,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 405.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 406.04,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 404.64,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 406.24,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 407.17,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 407.64,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 407.64,
    r: 0.47
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 406.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 406.94,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 407.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 409,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 409.67,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 409.93,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 408.8,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 409.47,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 407.87,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 408.34,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 406.94,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 408.53,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 409.47,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 409.93,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 409.93,
    r: 0.47
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 408.57,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 409.23,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 410.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 411.29,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 411.96,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 412.23,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 411.1,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 411.76,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 410.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 410.63,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 409.23,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 410.83,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 411.76,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 412.23,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 412.23,
    r: 0.47
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 410.86,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 411.53,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 412.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 413.59,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 414.26,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 414.52,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 413.39,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 414.06,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 412.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 412.93,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 411.53,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 413.12,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 414.06,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 414.52,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 414.52,
    r: 0.47
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 413.16,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 413.82,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 414.76,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 415.89,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 416.56,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 416.82,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 415.69,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 416.35,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 414.76,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 415.22,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 413.82,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 415.42,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 416.35,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 416.82,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 416.82,
    r: 0.47
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 596.97,
    cy: 415.46,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.61,
    cy: 416.12,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.68,
    cy: 417.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.43,
    cy: 418.18,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 418.85,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.18,
    cy: 419.11,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.95,
    cy: 417.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.68,
    cy: 418.65,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.87,
    cy: 417.05,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.32,
    cy: 417.52,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.18,
    cy: 416.12,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 417.71,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.59,
    cy: 418.65,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.72,
    cy: 419.11,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.37,
    cy: 419.11,
    r: 0.47
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.99,
    cy: 92.87,
    r: 21.63,
    fill: "#6c63ff",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 918.99,
    cy: 145.87,
    r: 17.01,
    fill: "#6c63ff",
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.57,
    cy: 63.9,
    r: 6,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M237.86,724.25s7.13,9.33-3.29,23.41-19,26-15.55,34.76c0,0,15.73-26.16,28.54-26.52S252,740,237.86,724.25Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M237.86,724.25a11.49,11.49,0,0,1,1.46,2.92c12.49,14.68,19.15,28.38,7.14,28.73-11.19.32-24.61,20.32-27.82,25.37a9.11,9.11,0,0,0,.38,1.15s15.73-26.16,28.54-26.52S252,740,237.86,724.25Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M251.12,736.14c0,3.28-.37,5.94-.82,5.94s-.82-2.66-.82-5.94.46-1.74.91-1.74S251.12,732.85,251.12,736.14Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#ffd037"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M255.67,740.06c-2.88,1.57-5.39,2.52-5.61,2.12s1.94-2,4.83-3.57,1.74-.43,2,0S258.56,738.49,255.67,740.06Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#ffd037"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M200.17,724.25s-7.13,9.33,3.29,23.41,19,26,15.56,34.76c0,0-15.74-26.16-28.54-26.52S186.08,740,200.17,724.25Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.17,724.25a11.49,11.49,0,0,0-1.46,2.92c-12.49,14.68-19.15,28.38-7.14,28.73,11.19.32,24.61,20.32,27.83,25.37a11.06,11.06,0,0,1-.38,1.15s-15.74-26.16-28.54-26.52S186.08,740,200.17,724.25Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186.91,736.14c0,3.28.37,5.94.82,5.94s.82-2.66.82-5.94-.46-1.74-.91-1.74S186.91,732.85,186.91,736.14Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#ffd037"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M182.36,740.06c2.88,1.57,5.39,2.52,5.61,2.12s-1.94-2-4.83-3.57-1.74-.43-2,0S179.47,738.49,182.36,740.06Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#ffd037"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.02,
    cy: 842.35,
    rx: 74.6,
    ry: 11.45,
    transform: "translate(-172.73 -17.13) rotate(-4.05)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M257.41,769.85l-.36,2.91-.5,4.12-.2,1.71-.5,4.12-.22,1.72-.5,4.11-5.71,46.8c-.51,4.18-7.33,7.43-15.57,7.43H204.18c-8.24,0-15.05-3.25-15.56-7.43l-5.72-46.8-.5-4.11-.21-1.72-.51-4.12-.2-1.71-.5-4.12-.36-2.91c-.29-2.37,3.41-4.36,8.07-4.36h60.66C254,765.49,257.7,767.48,257.41,769.85Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#65617d"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.34 738.04 142.84 742.15 67.76 742.15 67.26 738.04 143.34 738.04",
    fill: "#9d9cb5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.63 743.87 142.13 747.99 68.48 747.99 67.97 743.87 142.63 743.87",
    fill: "#9d9cb5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.91 749.7 141.41 753.81 69.19 753.81 68.69 749.7 141.91 749.7",
    fill: "#9d9cb5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "701.13 403.44 728.45 404.83 683.42 419.01 660.36 417.68 701.13 403.44",
    opacity: 0.1
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "701.12 402.25 728.44 403.65 683.4 417.83 660.34 416.49 701.12 402.25",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M811.61,440.08c1.07-.47,2.23.38,3.38.58.66.12,1.34,0,2,.1,1.34.16,2.68,1,4,.57Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#d3dae1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M810.21,440.92c1.07-.47,2.23.38,3.38.58.66.12,1.34,0,2,.1,1.34.16,2.68,1,3.95.56Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#d3dae1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M807,442.6c1.07-.47,2.23.38,3.39.58.65.12,1.33,0,2,.1,1.34.16,2.68,1,4,.56Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#d3dae1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M876.08,432.82s-3.42,15.92,11.79,17.8l.94-1.76S877,437.77,876.08,432.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M893.65,448.74l-3.54.75-.35.07s-9.44-7.66-9.32-24.76a42.22,42.22,0,0,0,4.51,7.13C888.69,436.88,892.94,443.49,893.65,448.74Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M894.84,450.38a2.22,2.22,0,0,1-1.9.24c-9.08-2.12-6-31.71-6-31.71.5.24,1.05,4,3.14,8.86C893.73,436.31,897.76,448.23,894.84,450.38Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M915,432.82s.59,15.92-14.62,17.8l-.94-1.76S914,437.77,915,432.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M910.62,424.8c.12,17.1-12.14,24.76-12.14,24.76l-.36-.07-3.53-.75c.7-5.25,5-11.86,8.69-16.81A38.47,38.47,0,0,1,910.62,424.8Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M898.07,448.83a5.74,5.74,0,0,1-2,1.55h0a3.86,3.86,0,0,1-.75.24c-2.23.53-3-1.09-2.88-3.82.21-4.88,3.27-13.33,6-19.65a24.53,24.53,0,0,1,5.7-8.24S904,442,898.07,448.83Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M895.53,408.53s-10.14,36-1.41,41.39S897.77,411.72,895.53,408.53Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M876.08,432.82s-3.42,15.92,11.79,17.8l.94-1.76S877,437.77,876.08,432.82Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M893.65,448.74l-3.54.75-.35.07s-9.44-7.66-9.32-24.76a42.22,42.22,0,0,0,4.51,7.13C888.69,436.88,892.94,443.49,893.65,448.74Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M894.84,450.38a2.22,2.22,0,0,1-1.9.24c-9.08-2.12-6-31.71-6-31.71.5.24,1.05,4,3.14,8.86C893.73,436.31,897.76,448.23,894.84,450.38Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M915,432.82s.59,15.92-14.62,17.8l-.94-1.76S914,437.77,915,432.82Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M910.62,424.8c.12,17.1-12.14,24.76-12.14,24.76l-.36-.07-3.53-.75c.7-5.25,5-11.86,8.69-16.81A38.47,38.47,0,0,1,910.62,424.8Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M898.07,448.83a5.74,5.74,0,0,1-2,1.55h0a3.86,3.86,0,0,1-.75.24c-2.23.53-3-1.09-2.88-3.82.21-4.88,3.27-13.33,6-19.65a24.53,24.53,0,0,1,5.7-8.24S904,442,898.07,448.83Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M895.53,408.53s-10.14,36-1.41,41.39S897.77,411.72,895.53,408.53Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M876.08,432.82s-2,15.92,13.2,17.8l.94-1.76S877,437.77,876.08,432.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M895.06,448.74l-3.54.75-.35.07s-10.85-7.66-10.73-24.76c0,0,2.78,3,5.92,7.13C890.1,436.88,894.35,443.49,895.06,448.74Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M895.06,448.74l-3.54.75c-3.35-2.95-4.68-10.63-5.16-17.56C890.1,436.88,894.35,443.49,895.06,448.74Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M896.26,450.38a2.25,2.25,0,0,1-1.91.24c-9.08-2.12-7.42-31.71-7.42-31.71.5.24,2.47,4,4.55,8.86C895.15,436.31,899.17,448.23,896.26,450.38Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M915,432.82s2,15.92-13.2,17.8l-.94-1.76S914,437.77,915,432.82Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M910.62,424.8c.12,17.1-10.73,24.76-10.73,24.76l-.35-.07-3.54-.75c.7-5.25,5-11.86,8.7-16.81C907.84,427.78,910.62,424.8,910.62,424.8Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M904.7,431.93c-.46,6.46-1.64,13.57-4.51,16.9a6.77,6.77,0,0,1-.65.66l-3.54-.75C896.7,443.49,901,436.88,904.7,431.93Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M899.48,448.83a5.62,5.62,0,0,1-2,1.55h0a4,4,0,0,1-.74.24c-2.24.53-3-1.09-2.89-3.82.22-4.88,3.28-13.33,6-19.65,2-4.56,3.81-8,4.29-8.24C904.14,418.91,905.42,442,899.48,448.83Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M896.26,450.38a2.55,2.55,0,0,1-1.44-.46c-4.27-2.66-4.36-12.65-3.34-22.15C895.15,436.31,899.17,448.23,896.26,450.38Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M899.48,448.83c-.49,1.06-1.15,1.62-2,1.55h0a3,3,0,0,1-1.21-.46,6.55,6.55,0,0,1-2.42-3.12c.22-4.88,3.28-13.33,6-19.65C900.83,435.92,901.16,445.23,899.48,448.83Z",
    transform: "translate(-113.71 -34.73)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M895.53,408.53s-8.72,36,0,41.39S897.77,411.72,895.53,408.53Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#6c63ff"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "795.5 416.96 794.89 420.14 792.67 431.81 771.56 431.81 769.34 420.14 768.73 416.96 795.5 416.96",
    fill: "#65617d"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "795.5 416.96 794.89 420.14 769.34 420.14 768.73 416.96 795.5 416.96",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 763.66,
    y: 413.42,
    width: 36.31,
    height: 6.01,
    fill: "#65617d"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M975.07,499s71.76,45,56.06,117.4c-1.28,5.91-2.39,11.84-3.12,17.83C1025.14,657.69,1007.92,725,905.07,756v7l43.63-12.17,29.62-16.33,22.61-20.29,27.64-33.71L1041.4,653l4.7-36.22,2.67-41.36L1042.16,540l-15.59-23.07-19-14.78Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#d9d6df"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M313.73,692.15c-6.78,36-1.52,73.45,16.18,105.56,51.61,93.62,161.29,66.07,193.65,55.45,7.7-2.53,15.5-4.72,23.4-6.51L903.4,765.87c122.67-21.33,148-120.67,148-120.67,24.29-76.62,7.64-121.26-14.34-146.56a86.77,86.77,0,0,0-70.21-29.34l-42.28,2.24-375.83,41C373.05,514.42,326.12,626.25,313.73,692.15Zm34.81,4.51C360.39,640,406.87,557.82,556.36,552.75c6.86-.24,13.71-.84,20.52-1.75L913,506.1l38.92-2c29.24-1.47,57.46,12.14,73.67,36.51,15.48,23.29,23.85,60,4.7,117.07,0,0-23.43,86.72-136.87,105.35L564.19,833.53c-7.49,1.6-14.89,3.56-22.2,5.82-29.86,9.22-129.15,32.6-177.38-45.92C346.88,764.56,341.6,729.82,348.54,696.66Z",
    transform: "translate(-113.71 -34.73)",
    fill: "#e1dee5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceControlOfo1);
export default __webpack_public_path__ + "static/media/voice_control_ofo1.b18f68fab9d54627480182092fb79d41.svg";
export { ForwardRef as ReactComponent };